const al = {
    call_me_back_title: 'Call me back',
    call_me_back_daily_request: 'Mundësi ditore',
    call_me_back_history_btn: 'Shiko historinë',
    call_me_back_select_recipiant: 'Zgjidh marrësin',
    call_me_back_contacts: 'Kontaktet e tua',
    call_me_back_send_request: 'Dërgo kërkesë tek',
    call_me_back_mobile_no: 'Numri i telefonit',
    call_me_back_wrong_phone_format: 'Numër jo i vlefshëm',
    call_me_back_confirm: 'Konfirmo',
    call_me_back_success_title: 'Sukses!',
    call_me_back_success_description: 'Kërkesa juaj u dërgua me sukses',
    call_me_back_error_title: 'Ups, ka ndodhur një gabim!',
    call_me_back_default_error: 'Diçka shkoi keq, provoni sërish kërkesën tuaj',
    call_me_back_history_empty_text: 'Ju nuk keni asnjë kërkesë të mëparshme dërguar miqve të Vodafone.',
    call_me_back_history_header: 'Historia',
    call_me_back_service_description: 'Call me back është një shërbim me anë të të cilit mund të dërgoni kërkesë telefonate drejt miqve tuaj Vodafone nëse keni balance më pak se ',
    call_me_back_service_amount: '27 Lekë',
    call_me_back_button: 'Kthehu',
}

export default al
